import PostBase from './postbase'
export default class Card extends PostBase{
    order:number;
    containerClass:string;
    imageUrl:string;
    imageId:number;
    name:string;

    constructor() {
        super();
  	}
}